import React from "react";

import { Avatar } from "@whoosh/design-system/src/components/display/Avatar";
import { Box } from "@whoosh/design-system/src/components/primitive";

import { EventSignUpRegistration } from "../../../types";

type Props = {
  registration: EventSignUpRegistration;
};

export const FilledRegistrationSpot = ({ registration }: Props) => {
  const avatarType =
    registration.type === "MEMBER"
      ? "member"
      : registration.type === "CUSTOMER"
      ? "customer"
      : "guest";

  return (
    <Box alignItems="center" width={40} height={40} justifyContent="center">
      <Avatar
        type={avatarType}
        size="sm"
        firstName={registration.registrant.firstName}
        lastName={registration.registrant.lastName}
        profileImagePublicId={registration.registrant.profileImage?.publicId}
      />
    </Box>
  );
};
